import { createRouter, createWebHistory } from 'vue-router';
import { ref } from 'vue';
import { message } from '🔗/utils/utils';

import stores from '@/stores';

import { requests } from '🔗/utils/requests';

const componentKey = ref('initial');

const handleRouterError = (error) => {
    const t = stores.locale().t();
    const errors = [
        {
            code: ['fetch', 'load', 'dynamically', 'importing'],
            action: () => message.error(t('common.errors.importError'))
        }
    ];

    const errorWords = error.message.toLowerCase().split(' ');
    const action = errors.find((item) => item.code.some((r) => errorWords.indexOf(r) !== -1));

    if (action) {
        return action.action();
    } else {
        message.error(error.message);
    }
};

const goMusic = (to, from, next) => {
    next({ name: 'music' });
};

const routes = [
    {
        path: '/empty',
        name: 'empty',
        component: () => import('../pages/Empty.vue'),
        abort: []
    },
    {
        path: '/artists',
        name: 'artists',
        component: () => import('../pages/Artists/Artists.vue'),
        abort: []
    },
        {
            path: '/artists/:code',
            name: 'artist',
            component: () => import('../pages/Artists/Artist.vue'),
            props: true,
            abort: []
        },
            {
                path: '/artists/:code/tracks',
                name: 'artist-tracks',
                component: () => import('../pages/Artists/Tracks.vue'),
                props: true,
                abort: []
            },
            {
                path: '/artists/:code/releases',
                name: 'artist-releases',
                component: () => import('../pages/Artists/Releases.vue'),
                props: true,
                abort: []
            },
    {
        path: '/releases/:id',
        name: 'release',
        component: () => import('../pages/Releases/Release.vue'),
        props: true,
        abort: []
    },
    {
        path: '/playlists/:id',
        name: 'playlist',
        component: () => import('../pages/Playlists/Playlist.vue'),
        props: true,
        abort: []
    },
    {
        path: '/music',
        name: 'music',
        component: () => import('../pages/Music/Music.vue'),
        abort: []
    },
        {
            path: '/categories/:code',
            name: 'category',
            component: () => import('../pages/Dictionaries/Category.vue'),
            props: true,
            abort: []
        },
        {
            path: '/moods/:code',
            name: 'mood',
            component: () => import('../pages/Dictionaries/Mood.vue'),
            props: true,
            abort: []
        },
        {
            path: '/genres/:code',
            name: 'genre',
            component: () => import('../pages/Dictionaries/Genre.vue'),
            props: true,
            abort: []
        },
    {
        path: '/favorite',
        name: 'favorite',
        component: () => import('../pages/Favorite/Favorite.vue'),
        abort: []
    },
        {
            path: '/favorite/artists',
            name: 'favorite-artists',
            component: () => import('../pages/Favorite/Artists/Artists.vue'),
            abort: []
        },
        {
            path: '/favorite/releases',
            name: 'favorite-releases',
            component: () => import('../pages/Favorite/Releases/Releases.vue'),
            abort: []
        },
        {
            path: '/favorite/tracks',
            name: 'favorite-tracks',
            component: () => import('../pages/Favorite/Tracks/Tracks.vue'),
            abort: []
        },
        {
            path: '/favorite/playlists',
            name: 'favorite-playlists',
            component: () => import('../pages/Favorite/Playlists/Playlists.vue'),
            abort: []
        },
        {
            path: '/favorite/my-artists',
            name: 'favorite-my-artists',
            component: () => import('../pages/Favorite/MyArtists/MyArtists.vue'),
            abort: []
        },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('../pages/Settings/Settings.vue'),
        abort: []
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('../pages/Error.vue'),
        abort: []
    },
    {
        path: '/access-denied',
        name: 'access-denied',
        component: () => import('../pages/AccessDenied.vue'),
        abort: []
    },
    {
        path: '/username-required',
        name: 'username-required',
        component: () => import('../pages/UsernameRequired.vue'),
        abort: []
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'error-page',
        beforeEnter: goMusic
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
    routes
});

router.back = function (path) {
    this.options?.history?.state?.back ? this.go(-1) : this.push(path || '/');
};

let lastPosition = window.history.state?.position;
let backFlag = false;


router.beforeEach((to, from, next) => {
    const currentPosition = window.history.state?.position;
    const isBack = currentPosition < lastPosition

    // if (isBack) {
    //     message.error(`BACK, ${lastPosition} -> ${currentPosition}`);
    // }

    if (isBack) {
        if (stores.modals().back()) {
            // message.success('BACK SUCCESS --- 3');
            backFlag = true;
            history.go(1);
            return;
        }

    }

    // stores.modals().closeAllQuiet(); // temp

    if (from?.name) {
        routes.forEach((item) => {
            if (item?.name === from?.name && item.abort?.length) {
                item.abort.forEach((code) => {
                    if (code.split(':id').length === 1) {
                        requests[code].abort();
                    } else {
                        requests[code.split(':id')[0]].abort(from.params.id);
                    }
                });
            }
        });
    }

    if (to?.name && stores.nav().page !== to.name) {
        stores.nav().setPage(to.name);
    }
    next();
});

router.afterEach((to, from) => {
    if (!backFlag) {
        stores.modals().closeAllQuiet(); // temp
    }


    // console.log(to.name, from.name, backFlag)
    // if (to.name === from.name && !backFlag) {
    //     // Обновляем ключ, например, с помощью timestamp
    //     componentKey.value = `${to.fullPath || to.name || 'default'}-${Date.now()}`;
    // } else {
    //     // Для других маршрутов просто ключ равен имени маршрута (или пути)
    //     componentKey.value = to.fullPath || to.name || 'default';
    // }

    const getKey = (payload) => {
        // Формируем ключ с учетом параметров
        const paramString = Object.keys(payload.params).filter(key => ['id', 'code'].indexOf(key) !== -1)
            .sort()
            .map(key => `${key}=${payload.params[key]}`)
            .join('&');

        const baseKey = payload.name || payload.path || 'default';
        return paramString ? `${baseKey}?${paramString}` : baseKey;
    }

    // Формируем ключ с учетом параметров
    const fromKey = getKey(from);
    const toKey = getKey(to);

    if (fromKey === toKey && !backFlag) {
        // Если переход на тот же маршрут, обновляем с timestamp
        componentKey.value = `${toKey}-${Date.now()}`;
    } else {
        const isSame = componentKey.value.startsWith(toKey + '-');

        if (!isSame) {
            // Иначе просто ключ с параметрами
            componentKey.value = toKey;
        }
    }

    backFlag = false;
    lastPosition = window.history.state?.position;
});

router.onError(handleRouterError);


router.isReady().then(() => {
    const startParam = stores.messengers().getStartParam();

    if (!startParam) {
        return;
    }

    const params = {};

    startParam.split('__').forEach(item => {
        params[item[0]] = item.slice(2);
    });

    if (!Object.keys(params).length) {
        return;
    }

    if (params.a) {
        router.push({ name: 'artist', params: { code: params.a } });
    }

    if (params.r) {
        router.push({ name: 'release', params: { id: params.r } });
    }

    if (params.m) {
        router.push({ name: 'mood', params: { code: params.m } });
    }

    if (params.c) {
        router.push({ name: 'category', params: { code: params.c } });
    }

    if (params.g) {
        router.push({ name: 'genre', params: { code: params.g } });
    }

    if (params.p) {
        router.push({ name: 'playlist', params: { id: params.p } });
    }

    if (params.t) {
        console.log(params.t);
    }
});

export { componentKey };
export default router;
